// import Home from "../views/web/Home.vue";

const _import = path => r => require.ensure([], () => r(require('../views/' + path + '.vue')));

export const constantRouterMap = [
    {path: '/', redirect: '/menuHome', hidden: true},
    // {path: '//web/menu1', component: _import('web/menu1'), hidden: true},
    {path: '/menuHome', component: () => import(/* webpackChunkName: "group-menuHome" */ '../views/web/menuHome.vue'), hidden: true},
    {path: '/payCashier', component: () => import(/* webpackChunkName: "group-payCashier" */ '../views/web/buy/payCashier.vue'), hidden: true},
    {path: '/404', component: _import('errorPage'), hidden: true},
    {path: '*', redirect: '/404', hidden: true},
    {
        path: '/projectDetail',
        name: 'ProjectDetail',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/projectDetail/projectDetail.vue'),
    },
    {
        path: '/projectDetailLy',
        name: 'ProjectDetailLy',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/projectDetailLy/projectDetail.vue'),
    },
    {
        path: '/projectDetailNmg',
        name: 'ProjectDetailNmg',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/projectDetailNmg/projectDetail.vue'),
    },
    {
        path: '/biddingProduct/:projectId',
        name: 'BiddingProduct',
        meta:{
            label:"投标产品"
        },
        authority: '1',
        // component: _import('web/buy/biddingProduct'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/biddingProduct.vue'),
    },
    
    {
        path: '/biddingProductLy/:projectId',
        name: 'BiddingProductLy',
        meta:{
            label:"履约产品"
        },
        authority: '1',
        // component: _import('web/buy/biddingProductLy'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/biddingProductLy.vue'),
    },
    {
        path: '/biddingProductNmg/:projectId',
        name: 'BiddingProductNmg',
        meta:{
            label:"农民工工资支付产品"
        },
        authority: '1',
        // component: _import('web/buy/biddingProductNmg'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/biddingProductNmg.vue'),
    },
    
    {
        path: '/biddingProductGtzy/:projectId',
        name: 'BiddingProductGtzy',
        meta:{
            label:"国土资源保函"
        },
        authority: '1',
        // component: _import('web/buy/biddingProductGtzy'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/biddingProductGtzy.vue'),
    },
    {
        path: '/buyProcessPre/:orderId',
        name: 'BuyProcessPre',
        meta:{
            label:"我的申请"
        },
        authority: '1',
        // component: _import('web/buy/buyProcess'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/buyProcessPre.vue'),
    },
    {
        path: '/buyProcess/:orderId',
        name: 'BuyProcess',
        meta:{
            label:"我的申请"
        },
        authority: '1',
        // component: _import('web/buy/buyProcess'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/buy/buyProcess.vue'),
    },
];


const frameIn = [
    //web
    /*{
        path: "/web",
        name: "Home",
        component: () => import(/!* webpackChunkName: "group-foo" *!/ '../views/web/Home.vue'),
        
    },*/
    {
        path: '/menu1',
        name: 'Menu1',
        authority: '1',
        meta:{
            label:"首页"
        },
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/menu1.vue'),
    },
    {
        path: '/password',
        name: 'Password',
        authority: '1',
        meta:{
            label:"忘记密码"
        },
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/password/index.vue'),
    },
    {
        path: '/projectDetail',
        name: 'ProjectDetail',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/projectDetail/projectDetail.vue'),
    },
    {
        path: '/projectDetailLy',
        name: 'ProjectDetailLy',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/projectDetailLy/projectDetail.vue'),
    },
    {
        path: '/projectDetailNmg',
        name: 'ProjectDetailNmg',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetail'),
        component: () => import(/* webpackChunkName: "group-foo2" */ '../views/web/projectDetailNmg/projectDetail.vue'),
    },
    {
        path: '/biddingProduct/:projectId',
        name: 'BiddingProduct',
        meta:{
            label:"投标产品"
        },
        authority: '1',
        // component: _import('web/buy/biddingProduct'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/buy/biddingProduct.vue'),
    },
    
   
    {
        path: '/buyProcess/:orderId',
        name: 'BuyProcess',
        meta:{
            label:"我的申请"
        },
        authority: '1',
        // component: _import('web/buy/buyProcess'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/buy/buyProcess.vue'),
    },
    /*{
        path: '/projectDetailF',
        name: 'ProjectDetailF',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetailF/index'),
        component: () => import(/!* webpackChunkName: "group-foo1" *!/ '../views/web/projectDetail/projectDetailF/index.vue'),
    },*/
    /*{
        path: '/projectDetailE',
        name: 'ProjectDetailE',
        authority: '1',
        meta:{
            label:"项目详情"
        },
        // component: _import('web/projectDetail/projectDetailE/index'),
        component: () => import(/!* webpackChunkName: "group-foo1" *!/ '../views/web/projectDetail/projectDetailE/index.vue'),
    },*/
    {
        path: '/menu2',
        name: 'Menu2',
        authority: '1',
        // component: _import('web/menu2'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/menu2.vue'),
    },
    {
        path: '/businessInfo',
        name: 'BusinessInfo',
        authority: '1',
        // component: _import('web/businessInfo'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/businessInfo.vue'),
    },
    {
        path: '/lybh',
        name: 'Lybh',
        authority: '1',
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/lybh.vue'),
    },
    {
        path: '/nmgbh',
        name: 'Nmgbh',
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/nmgbh.vue'),
    },
    {
        path: '/gtzybh',
        name: 'Gtzybh',
        authority: '1',
        // component: _import('web/businessInfo'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/gtzybh.vue'),
    },
    {
        path: '/manual',
        name: 'Manual',
        authority: '1',
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/manual.vue'),
    },
    /*{
        path: '/construction',
        name: 'Construction',
        authority: '1',
        component: () => import(/!* webpackChunkName: "group-construction" *!/ '../views/web/construction.vue'),
    },*/
    /*{
        path: '/people',
        name: 'People',
        authority: '1',
        // component: _import('web/people')
        component: () => import(/!* webpackChunkName: "group-people" *!/ '../views/web/people.vue'),
    },*/
    /*{
        path: '/agriculture',
        name: 'Agriculture',
        authority: '1',
        // component: _import('web/agriculture')
        component: () => import(/!* webpackChunkName: "group-agriculture" *!/ '../views/web/agriculture.vue'),
    },*/
    {
        path: '/moreProjects',
        name: 'MoreProjects',
        authority: '1',
        // component: _import('web/moreProjects/index')
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/moreProjects/index.vue'),
    },
    {
        path: '/newsDetails',
        name: 'NewsDetails',
        authority: '1',
        // component: _import('web/newsDetails/index')
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/newsDetails/index.vue'),
    },
    {
        path: '/announceNeeds',
        name: 'AnnounceNeeds',
        authority: '1',
        // component: _import('web/announceNeeds')
        component: () => import(/* webpackChunkName: "group-announceNeeds" */ '../views/web/announceNeeds.vue'),
    },
    {
        path: '/noviciateGuide',
        name: 'NoviciateGuide',
        authority: '1',
        // component: _import('web/noviciateGuide')
        component: () => import(/* webpackChunkName: "group-noviciateGuide" */ '../views/web/noviciateGuide.vue'),
    },
    {
        path: '/accountMine',
        name: 'AccountMine',
        authority: '1',
        // component: _import('web/account/main'),
        component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/main.vue'),
        children: [
            {
                path: '/accountInfo',
                name: 'AccountInfo',
                authority: '1',
                // component: _import('web/account/info'),
                component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/info.vue'),
            },
            {
                path:'/artificial',
                name:'Artificial',
                authority:'1',
                component:_import('web/account/components/cooperation/artificial')
                // component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/components/cooperation/artificial.vue'),
            },
            {
                path: '/cooperation',
                name: 'Cooperation',
                authority: '1',
                component: _import('web/account/cooperation'),
                // component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/cooperation.vue'),
            },
            {
                path: '/focus',
                name: 'Focus',
                authority: '1',
                // component: _import('web/account/focus'),
                component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/focus.vue'),
            },
            {
                path: '/order',
                name: 'Order',
                authority: '1',
                // component: _import('web/account/order'),
                component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/order.vue'),
            },
            {
                path: '/invoice',
                name: 'Invoice',
                authority: '1',
                component: _import('web/account/invoice'),
                // component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/invoice.vue'),
            },
            {
                path: '/invoiceDetail',
                name: 'InvoiceDetail',
                authority: '1',
                // component: _import('web/account/components/invoice/billManegeDetail'),
                component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/components/invoice/billManegeDetail.vue'),
            },
            /*{
                path: '/requisite',
                name: 'Requisite',
                authority: '1',
                // component: _import('web/account/requisite'),
                component: () => import(/!* webpackChunkName: "group-foo1" *!/ '../views/web/account/requisite.vue'),
            },*/
            {
                path: '/shoppingCart',
                name: 'ShoppingCart',
                authority: '1',
                component: _import('web/account/shoppingCart'),
                // component: () => import(/* webpackChunkName: "group-foo1" */ '../views/web/account/shoppingCart.vue'),
            },
        ],
        redirect: '/accountMine/accountInfo',
    },
];
export default [...frameIn, ...constantRouterMap];
export const menuRouter = [...constantRouterMap, ...frameIn];


// 根据name获取路由path
export const getPathByName = name => {
    let path = '';
    menuRouter.map(item => {
        if (item.children)
            item.children.map(ch => {
                if (ch.name === name) {
                    path = item.path + '/' + ch.path
                }
            });
    });
    return path;
};


